import axios from 'axios'

const getAxiosInstance = () => {
  axios.defaults.baseURL = process.env.TRACEABILITY_BASE_URL

  return axios
}

export const getNtoList = async () => await getAxiosInstance().get('/ntosNames')

export const getProductionNTOs = async filter =>
  await getAxiosInstance().get('/ntos', { params: filter })

export const getLogisticNTOsByBatches = async filter =>
  await getAxiosInstance().get('/lot/ntos', { params: filter })

export const getLogisticNTOsBySamples = async filter =>
  await getAxiosInstance().get('/samples/ntos', { params: filter })

export const getProductionIndicators = async filter =>
  await getAxiosInstance().get('/exams/indicators', { params: filter })

export const getLogisticBatchIndicators = async filter =>
  await getAxiosInstance().get('/lot/indicators', { params: filter })

export const getLogisticSampleIndicators = async filter =>
  await getAxiosInstance().get('/samples/indicators', { params: filter })

export const getBatchSearchDetailsByBarcode = async barcode =>
  await getAxiosInstance().get(`/lotDetails/${barcode}`)
